<script>
import { faqCategoryService } from "../../services";
import { required} from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import DropzonePopup from "../../components/widgets/dropzone-popup";

export default {
  components: { faqCategoryService, DropzonePopup},
    data() {
        return {
            checked: true,
            url: null,
            config: config,
            typeform: {
                name: "",
                name_lang: "",
                status: "1",
                icon_img: "",
            },
        };
    },
    validations: {
        typeform: {
            name:{
                required,
            },
            name_lang: {
                required
            },
            icon_img:{
                required,
            }
        },
    },
    methods: {
        addFaqCategory(){
            this.$v.typeform.$touch();
            if (this.$v.typeform.$invalid) {
                return;
            } else {
                faqCategoryService.addFaqCategory(this.typeform).then((response) => {
                    if (response.data.code === 200) {
                        success_message(response.data.message);
                        this.$router.push({ name: "faq-category-list" });
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        },
    },
};
</script>
<template>
    <form @submit.prevent="addFaqCategory">
        <div class="card">
            <div class="card-body">
                <!-- <h4 class="card-title">{{ trans.get('__JSON__.Brand Information') }}</h4> -->
                <p class="card-title-desc"></p>
                <div class="row">
                    <div class="col-sm-6" v-if="$auth.setting">
                        <div class="form-group">
                           <label class="required">{{ trans.trans('__JSON__.Faq Category Name Primary',{ lang: $auth.langauges[0].name })}}</label>
                            <input
                                id="name"
                                v-model="$v.typeform.name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Faq Category Name Primary',{ lang: $auth.langauges[0].name })"
                                name="name"
                                :class="{ 'is-invalid': $v.typeform.name.$error }"
                            />
                            <div v-if="$v.typeform.name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.name.required">{{ trans.get('__JSON__.Please enter faq category name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6" v-if="$auth.langauges[1].name !== 'No Secondary Language'">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Faq Category Name Secondary',{ lang: $auth.langauges[1].name })}}</label>
                            <input
                                id="name_lang"
                                v-model="$v.typeform.name_lang.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Faq Category Name Secondary',{ lang: $auth.langauges[1].name })"
                                name="name_lang"
                                :class="{ 'is-invalid': $v.typeform.name_lang.$error }"
                            />
                            <div v-if="$v.typeform.name_lang.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.name_lang.required">{{ trans.get('__JSON__.Please enter faq category name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 vendor-status">
                        <b-form-group id="input-group-2" :label="trans.get('__JSON__.Status')" label-for="Status" >
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="swtich-data">
                                        <label class="switch">
                                            <input
                                                type="checkbox"
                                                id="togBtn"
                                                class="switch-on"
                                                name="status"
                                                v-model="typeform.status"
                                                true-value="1"
                                                false-value="0"
                                            />
                                            <div class="slider round">
                                                <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                                                <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-sm-3">
                        <label class="required">{{ trans.trans('__JSON__.Icon')}}</label>
                        <dropzone-popup
                            v-model="$v.typeform.icon_img.$model"
                            type="file"
                            id="icon_img"
                            name="image"
                            acceptedFiles=".jpeg,.jpg,.png"
                        />
                        <div v-if="$v.typeform.icon_img.$error" class="invalid-feedback cuisine-img">
                            <span
                                v-if="!$v.typeform.icon_img.required"
                            >{{ trans.get('__JSON__.Please select icon') }}.</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Add Faq Category') }}</button>
                        <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
                        <router-link
                            :to="{name:'faq-category-list'}"
                        >
                            <b-button 
                                type="button" 
                                variant="secondary" 
                                class="mt-3">
                                {{ trans.get('__JSON__.Cancel') }}
                            </b-button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>